// Boot-time sweep of localStorage keys written by pre-env-prefix builds.
// This branch renamed the auth keys to `${ENV}:...` (see auth.js) and the
// redux-persist key to `persist:${ENV}:root` (see store/index.js), but the
// rename alone leaves the old blobs — including the legacy `permissions`
// payload and the old persisted redux state — in localStorage forever.
// Runs on import (imported first in index.tsx, before the App module graph
// creates/rehydrates the store). Idempotent: removing absent keys is a no-op.
//
// Enumerated from the git history of common/auth.js on develop:
//   userToken / userName / permissions (un-prefixed auth keys)
//   persist:root (old un-prefixed redux-persist blob)
// `impersonation` is intentionally NOT swept — current code still uses it
// un-prefixed.
const LEGACY_KEYS = ['userToken', 'userName', 'permissions', 'persist:root']

try {
  LEGACY_KEYS.forEach((key) => localStorage.removeItem(key))
} catch {
  // localStorage unavailable (e.g. headless render) — nothing to sweep.
}

export {}
